export function IsStormvloed(story) {

    if(story?.includes("Stormvloed")) {
        return true
    }

    return false;
}

export function IsAgnoia(story) {

    if(story.includes("Agnoia")) {
        return true
    }

    return false;
}